import { useEffect, useState } from "react";
import { Modal, Spin } from "antd";
import { getWorkflowSlideUrl } from "../../utils/videoStorage";

const GlossaryExampleModal = ({ open, onClose, term, definition, imageFileName }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open || !imageFileName) return undefined;

    let cancelled = false;
    setLoading(true);
    setError(null);
    setImageUrl(null);

    getWorkflowSlideUrl(imageFileName)
      .then((url) => {
        if (!cancelled) setImageUrl(url);
      })
      .catch(() => {
        if (!cancelled) setError("Couldn't load the example image. Please try again.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [open, imageFileName]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={720}
      centered
      destroyOnHidden
      styles={{
        content: { borderRadius: 24, padding: 24 },
        mask: { background: "rgba(0, 0, 0, 0.45)" },
      }}
    >
      <div className="flex flex-col gap-4">
        <h2
          className="text-xl font-medium leading-7 tracking-[-0.2px] text-[rgba(0,0,0,0.85)] pr-8"
          style={{ fontFamily: "Satoshi, sans-serif" }}
        >
          {term}
        </h2>
        {definition && (
          <p
            className="text-sm font-normal leading-[22px] text-[rgba(0,0,0,0.65)]"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            {definition}
          </p>
        )}
        <div className="flex items-center justify-center min-h-[300px] bg-[#FAFAFA] rounded-2xl p-4">
          {loading && <Spin size="large" />}
          {!loading && error && (
            <p className="text-sm text-[rgba(0,0,0,0.55)]" style={{ fontFamily: "Inter, sans-serif" }}>
              {error}
            </p>
          )}
          {!loading && !error && imageUrl && (
            <img
              src={imageUrl}
              alt={`${term} example`}
              className="max-w-full max-h-[60vh] rounded-lg object-contain"
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default GlossaryExampleModal;
